module.exports = __webpack_public_path__ + "img/f41396f.jpg";